import { InvoicesApi } from 'api/invoicesApi';

export const openFile = async (id: number) => {
  const result = await InvoicesApi.getViewInvoiceUrl(id);
  if (result.data) {
    const url = result.data;
    window.open(url, '_blank');
  }
  if (result.error) {
    //TODO: handle error
  }
};
